/**
 * Frontend feature flags.
 *
 * COMMUNITY_ENABLED — Phase put on hold (May 2026). Setting to `false`
 * hides every Community surface across the app:
 *   • Header "Community" button + NotificationBell (community-only)
 *   • Dashboard JoinCommunityCard banner + MyPortfolioCommunityPosts
 *   • StockModal community sentiment chip, surfacer + TriangleSentimentRibbon
 *   • /community, /community/terms, /community/profile/:handle,
 *     /admin/community routes (fall through to Dashboard via "*")
 *   • Welcome-back popup (mounted only inside /community)
 *   • Glossary entries: "Community", "Community Average", "Community Handle"
 *
 * Flip this back to `true` to restore the entire community section.
 * No backend changes required — APIs stay live so existing data
 * (privacy settings, watchlists, etc.) is preserved.
 */
export const COMMUNITY_ENABLED = false;
